
export const subjects = [
    {
        id: 'classroombasics',
        projects: [
            {
                classroom: "Mrs. Patterson's class in North Carolina",
                projectLink: baseURL + 'project/lets-get-to-the-point/3158372',
                item: 'got crayons, colored pencils, and sharpeners',
                quote: 'We were literally having to use handheld pencil sharpeners to sharpen our pencils. We had stopped using colored pencils since it was too much trouble to sharpen them. The students were so excited to get the two pencil sharpeners in the library. They love using the sharpeners. I have many volunteers to help sharpen the pencils each day.',
                spritePosition: '0 -1336px',
            },
            {
                classroom: "Ms. Frankowiak's class in Wisconsin",
                projectLink: baseURL + 'project/paper-please/2942150',
                item: 'received reams of paper',
                quote: 'It is such a small, but wonderful, luxury to be able to reach into my cupboard and see several reams of inviting colors as I get copypaper. I hope that students fee this tiny spark of loveliness when they do their lessons on sky blue paper for music and character development or warm pink work packets for reading.',
                spritePosition: '-300px -1336px',
            },
            {
                classroom: "Mrs. Stimmel's class in Pennsylvania",
                projectLink: baseURL + 'project/a-dry-erase-dream/3005125/',
                item: 'received a dry-erase table and markers',
                quote: 'The dry erase table is a favorite space in our classroom. The students have all used dry erase boards in the past, but this was their first dry erase table. They love any opportunity given to work on the table. Students love working in small groups to practice skills or complete assigned tasks.',
                spritePosition: '-600px -1336px',
            },
        ],
    },
    {
        id: 'mathandscience',
        projects: [
            {
                classroom: "Ms. Mehta's class in California",
                projectLink: baseURL + 'project/hatching-chicks-in-the-kinder-classroom/1341553/',
                item: 'got an incubator to hatch chicks',
                quote: "My students were overjoyed to receive our incubators and brooder in the mail, and we can't wait to use them this spring to hatch chicks as part of our oviparous animals thematic unit!",
                spritePosition: '0 -536px',
            },
            {
                classroom: "Mrs. Chung's class in Hawaii",
                projectLink: baseURL + 'project/3d-makers-space-digital-design-center/1511349/',
                item: 'received a 3D printer',
                quote: "The students' learning and my teaching have changed as a result of this new equipment.",
                spritePosition: '-300px -536px',
            },
            {
                classroom: "Mr. Dinkel's class in Kansas",
                projectLink: baseURL + 'project/learning-with-legos/1492019/',
                item: 'received legos',
                quote: 'From the very first day, when student excitedly opened the large cardboard boxes during our class meeting revealing the Lego sets, to the lessons connecting important math concepts with the popular toy, student engagement has been present.',
                spritePosition: '-600px -536px',
            },
        ],
    },
    {
        id: 'musicandarts',
        projects: [
            {
                classroom: "Ms. Printz's class in Texas",
                projectLink: baseURL + 'project/we-need-paint-please-help/1530195/',
                item: 'got oil and acrylic paints for a mural',
                quote: 'Our students will create pieces that will get them scholarships, boost self-esteem...make their parents proud...create portfolios that will get them into college, and teach them things they never thought they would know.',
                spritePosition: '0 -336px',
            },
            {
                classroom: "Ms. Evan's class in Illinois",
                projectLink: baseURL + 'project/we-want-to-play-the-violin/1269128/',
                item: 'received violins',
                quote: 'Playing the violin has given our students something to talk about with others who also play the instrument or are simply musically inclined. They also feel part of something important.',
                spritePosition: '-300px -336px',
            },
            {
                classroom: "Mrs. Elser's class in California",
                projectLink: baseURL + 'project/field-trip-to-the-getty/1480908/',
                item: 'went on a Field Trip to the Getty',
                quote: 'Our students were able to see the small details of real art pieces...They interacted with the art; one of my favorite moments was seeing many students trying to mimic an angry face of one of the statues.',
                spritePosition: '-600px -336px',
            },
        ],
    },
    {
        id: 'historyandcivics',
        projects: [
            {
                classroom: "Ms. Moreno's class in Illinois",
                projectLink: baseURL + 'project/pcs-watches-selma/1494671/',
                item: 'watched Selma in theaters',
                quote: 'They understood the significance of viewing this movie, especially while being in the midst of Black History Month. Students were engaged in the showing, and gained insight by watching a critically acclaimed movie of the Selma movement.',
                spritePosition: '0 -936px',
            },
            {
                classroom: "Mr. McKinney's class in Connecticut",
                projectLink: baseURL + 'project/exploring-the-chinese-perspective-on-eco/1344510/',
                item: 'traveled to China',
                quote: "We experienced Chinese culture at its fullest and learned as much as we could about China's economic revolution and continued economic growth. I couldn't have asked for a better or more educational experience.",
                spritePosition: '-300px -936px',
            },
            {
                classroom: "Mrs. Serrano's class in California",
                projectLink: baseURL + 'project/help-us-make-egyptian-masks-for-mrs-ser/1441149/',
                item: 'made Egyptian burial masks',
                quote: 'Each of my students created their own Egyptian life mask, with the materials we received. We cut up the plaster into strips and the students worked with partners, who then carefully covered their faces with the plaster strips.',
                spritePosition: '-600px -936px',
            },
        ],
    },
    {
        id: 'literacyandlanguage',
        projects: [
            {
                classroom: "Ms. Sabatasso's class in California",
                projectLink: baseURL + 'project/more-books-please/1472822/',
                item: 'got books for their classroom library',
                quote: 'My students have enjoyed every single one of the books donated and it is apparent, many have increased their reading levels since receiving our shipment of chapter books from Amazon.',
                spritePosition: '0 -736px',
            },
            {
                classroom: "Mrs. Eiserman's class in Illinois",
                projectLink: baseURL + 'project/graphic-novels-gateway-to-readerly-live/1379171/',
                item: 'received graphic novels',
                quote: 'Those who never picked up a book before, or picked up random books that they quickly abandoned, are FLYING through the graphic novels. You helped instill an insatiable hunger for reading in some of my biggest struggling readers.',
                spritePosition: '-300px -736px',
            },
            {
                classroom: "Mrs. Elser's class in North Carolina",
                projectLink: baseURL + 'project/two-languages-to-build-one-community/1382041/',
                item: 'got language learning software',
                quote: 'Having Rosetta Stone has been very fulfilling for my students. I have seen the relationships between my students change, their communication become more fluid and our classroom community grow.',
                spritePosition: '-600px -736px',
            },
        ],
    },
    {
        id: 'specialneeds',
        projects: [
            {
                classroom: "Mr. Baum's class in Illinois",
                projectLink: baseURL + 'project/the-bulldog-blend-cafe/1349310/',
                item: 'opened up a coffee shop',
                quote: 'This cafe offers our students the invaluable experience to interact with people around them and work within rules and a schedule. They have blossomed under this fun responsibility and have taken true ownership of the cafe.',
                spritePosition: '0 -136px',
            },
            {
                classroom: "Ms. Kaminski's class in New York",
                projectLink: baseURL + 'project/night-at-the-museum/1287086/',
                item: 'spent the night at the museum',
                quote: 'The students were able to sleep over at the museum under the giant whale in the ocean life room. They were also able to hold starfish, see spiders, and explore the museum by flashlight.',
                spritePosition: '-300px -136px',
            },
            {
                classroom: "Ms. Griego's class in New Mexico",
                projectLink: baseURL + 'project/we-need-noise-canceling-headphones/1484924/',
                item: 'got noise canceling headphones',
                quote: 'The headphones block out everything around them and help them focus on their task at hand. I can not think you enough for helping our classroom.',
                spritePosition: '-600px -136px',
            },
        ],
    },
    {
        id: 'healthandsports',
        projects: [
            {
                classroom: "Ms. Fjellestad's class in Colorado",
                projectLink: baseURL + 'project/leave-no-child-inside-help-outdoor-club/440567/',
                item: 'went skiing and snowboarding',
                quote: 'You provided students with a fun-filled day that certainly opened their eyes to athletic and character-building activities they may choose to pursue in the future either through Outdoor Club or with their families.',
                spritePosition: '0 -1136px',
            },
            {
                classroom: "Ms. Jenning's class in Illinois",
                projectLink: baseURL + 'project/help-ejhs-live-fit/1459289/',
                item: 'got heart rate monitors',
                quote: 'These monitors have not only excited and helped motivate students in our PE classes but have offered a solid foundation for the educational side of physical activity.',
                spritePosition: '-300px -1136px',
            },
            {
                classroom: "Mrs. Hooten's class in Indiana",
                projectLink: baseURL + 'project/dinner-is-on-us/1503265/',
                item: 'received gardening supplies',
                quote: 'Not only will this project allow our students a wide range of environmental science experiences and knowledge, but also an opportunity to help feed their families.',
                spritePosition: '-600px -1136px',
            },
        ],
    },
    {
        id: 'racialjusticeandrepresentation',
        projects: [
            {
                classroom: "Ms. Garcia's class in California ",
                projectLink: baseURL + 'project/celebrate-diversity-with-literature/7030278/',
                item: 'books with diverse characters',
                quote: 'Our inclusive community celebrates diversity and our many cultural traditions through literature and art. Hearing their own stories, seeing their own faces in literature, and inspiring ethnic studies is important for my students.',
                spritePosition: '0 -1536px',
            },
            {
                classroom: "Ms. Kacarevic's class in New York",
                projectLink: baseURL + 'project/colors-of-the-world-art-supplies/6176584/',
                item: 'art supplies',
                quote: 'These art supplies will help my students to celebrate their diversity! Inclusive products like these really encourage students to express themselves with confidence and let their uniqueness shine through.',
                spritePosition: '-300px -1536px',
            },
            {
                classroom: "Mrs. Martin's class in Nevada",
                projectLink: baseURL + 'project/representation-matters/6249727/',
                item: 'books, magazine subscriptions, and musical instruments',
                quote: 'Our class is very enthusiastic to learn so many different things, including other cultures and their stories of differences. It is our hope that we can learn about others around us so we can see how similar we are and celebrate the differences that we all have!',
                spritePosition: '-600px -1536px',
            },
        ],
    },
];
